/* TWRD stacked-grid gallery: lodret scroll-indikator (Gymshark-stil).
   Desktop only (>= 1000px), samme braekpunkt som twrd-gallery-sticky.css.

   Datakilde: <media-gallery> er selve scroll-boksen i den sticky kolonne.
   Railen laeser dens scrollTop / scrollHeight / clientHeight og lytter paa
   dens eget 'scroll'-event. Ikke window.scrollY, ikke window.scrollTo. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(min-width: 1000px)');
  var MIN_THUMB = 28;

  var ARROW_UP =
    '<svg viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M3.5 12 9 6.5l5.5 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></svg>';
  var ARROW_DOWN =
    '<svg viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M3.5 6 9 11.5l5.5-5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></svg>';

  /* Den sticky kolonne. Railen skal ligge inde i den, ikke i den hoeje
     .product-single__media, som spaender hele indholdshoejden. */
  function mountOf(media) {
    return media.querySelector(':scope > sticky-scroll') || media;
  }

  function scrollerOf(media) {
    return media.querySelector('media-gallery');
  }

  function Rail(media) {
    this.media = media;
    this.mount = mountOf(media);
    this.scroller = scrollerOf(media);
    if (!this.scroller) return;
    this.grid = this.scroller.querySelector('.media-gallery__grid');
    if (!this.grid) return;

    this.el = document.createElement('div');
    this.el.className = 'twrd-gallery-rail';
    this.el.innerHTML =
      '<div class="twrd-gallery-rail__inner">' +
      '<button type="button" class="twrd-gallery-rail__btn" data-dir="-1" aria-label="Forrige billede">' +
      ARROW_UP +
      '</button>' +
      '<div class="twrd-gallery-rail__track"><div class="twrd-gallery-rail__thumb"></div></div>' +
      '<button type="button" class="twrd-gallery-rail__btn" data-dir="1" aria-label="Naeste billede">' +
      ARROW_DOWN +
      '</button>' +
      '</div>';

    this.track = this.el.querySelector('.twrd-gallery-rail__track');
    this.thumb = this.el.querySelector('.twrd-gallery-rail__thumb');
    this.prev = this.el.querySelector('[data-dir="-1"]');
    this.next = this.el.querySelector('[data-dir="1"]');
    this.mount.appendChild(this.el);

    this.ticking = false;

    var self = this;
    this.onScroll = function () {
      if (self.ticking) return;
      self.ticking = true;
      window.requestAnimationFrame(function () {
        self.update();
        self.ticking = false;
      });
    };
    this.onResize = function () {
      self.measure();
      self.update();
    };
    this.onClick = function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-dir]') : null;
      if (btn) self.step(Number(btn.getAttribute('data-dir')));
    };

    this.el.addEventListener('click', this.onClick);
    this.bindDrag();
    /* scroll-kilden er boksen, ikke vinduet */
    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    if (MQ.addEventListener) MQ.addEventListener('change', this.onResize);

    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(this.onResize);
      this.ro.observe(this.grid);
      this.ro.observe(this.scroller);
    }
    if ('MutationObserver' in window) {
      this.mo = new MutationObserver(this.onResize);
      this.mo.observe(this.grid, { childList: true });
    }

    this.built = true;
    this.measure();
    this.update();
  }

  /* Theme editor og variantskift bygger sektionen om: drop lyttere og
     observere, ellers bliver der en handler tilbage hver gang. */
  Rail.prototype.destroy = function () {
    if (!this.built) return;
    this.built = false;
    if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
    this.unbindDrag();
    window.removeEventListener('resize', this.onResize);
    if (MQ.removeEventListener) MQ.removeEventListener('change', this.onResize);
    if (this.ro) this.ro.disconnect();
    if (this.mo) this.mo.disconnect();
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
    this.media.__twrdRail = null;
  };

  /* sizes fra Liquid regner med halv kolonne ("/ 2"). En bred flise fylder
     hele kolonnen, saa uden rettelsen henter retina et for lille billede.
     Originalen gemmes i data-twrd-sizes, saa vi kan skifte tilbage. */
  function fixWideSizes(item, wide) {
    var imgs = item.querySelectorAll('img[sizes]');
    for (var k = 0; k < imgs.length; k++) {
      var img = imgs[k];
      var base = img.getAttribute('data-twrd-sizes');
      if (base == null) {
        base = img.getAttribute('sizes') || '';
        img.setAttribute('data-twrd-sizes', base);
      }
      var next = wide ? base.replace(/ \/ 2\)/g, ')') : base;
      if (img.getAttribute('sizes') !== next) img.setAttribute('sizes', next);
    }
  }

  /* Rytme: to smaa, en stor, to smaa, en stor. Hver 3. tile spaender begge
     kolonner, og en enlig sidste tile goer det ogsaa.
     canWide[i] er false for udsnit og naerbilleder (data-twrd-nowide, sat af
     twrd-variant-gallery.js i auto-raekkefoelge). De bliver aldrig store.
     banned er indekset paa en flise der skal forblive lille i dette forsoeg. */
  function planWidths(canWide, banned) {
    var n = canWide.length;
    var wides = [];
    var col = 0;
    var since = 0;
    for (var i = 0; i < n; i++) {
      var due = since >= 2 && col === 0;
      var wide = due && canWide[i] && i !== banned;
      if (!wide && i === n - 1 && col === 0 && canWide[i]) wide = true;
      wides.push(wide);
      if (wide) {
        col = 0;
        since = 0;
      } else {
        col = (col + 1) % 2;
        since += 1;
      }
    }
    return { wides: wides, lonely: col === 1 };
  }

  /* Ender raekken med en enlig lille flise (et udsnit der ikke maa vaere
     stort), saa proev at lade een stor flise vaere lille, bagfra. Det flytter
     pariteten. Lykkes det ikke, faar den sidste flise lov at vaere stor. */
  function rhythmFor(canWide) {
    var plan = planWidths(canWide, -1);
    if (!plan.lonely) return plan.wides;
    for (var i = canWide.length - 1; i >= 0; i--) {
      if (!plan.wides[i]) continue;
      var retry = planWidths(canWide, i);
      if (!retry.lonely) return retry.wides;
    }
    return plan.wides.map(function (wide, index) {
      return index === canWide.length - 1 ? true : wide;
    });
  }

  /* Story order (twrd-gallery-order.liquid, data-twrd-go on the grid): the
     rhythm runs on the main tiles only. Close-ups (.twrd-cu) have their own
     layout in twrd-pdp-details.css, extras (.twrd-go-extra) are hidden on
     desktop. Without data-twrd-go every tile counts, as before. */
  function isOutsideRhythm(item, story) {
    return story && (item.classList.contains('twrd-cu') || item.classList.contains('twrd-go-extra'));
  }

  function applyRhythm(grid) {
    var all = grid.querySelectorAll('.media-gallery__wrapper');
    var story = grid.hasAttribute('data-twrd-go');
    var items = [];
    var canWide = [];
    for (var c = 0; c < all.length; c++) {
      if (isOutsideRhythm(all[c], story)) {
        all[c].classList.remove('is-wide');
        fixWideSizes(all[c], all[c].classList.contains('twrd-cu--big'));
        continue;
      }
      items.push(all[c]);
      canWide.push(!all[c].hasAttribute('data-twrd-nowide'));
    }
    var wides = rhythmFor(canWide);
    for (var i = 0; i < items.length; i++) {
      items[i].classList.toggle('is-wide', wides[i]);
      fixWideSizes(items[i], wides[i]);
    }
  }

  /* Et "skridt" er hoejden paa den foerste flise plus grid-gappet. */
  Rail.prototype.measure = function () {
    applyRhythm(this.grid);
    var first = this.grid.querySelector('.media-gallery__wrapper');
    var gap = 0;
    try {
      var cs = window.getComputedStyle(this.grid);
      gap = parseFloat(cs.rowGap || cs.gridRowGap || '0') || 0;
    } catch (err) {
      gap = 0;
    }
    var h = first ? first.getBoundingClientRect().height : 0;
    /* Fallback naar gridet endnu ikke er maalt: halv boks-hoejde. */
    this.stepPx = Math.round(h + gap) || Math.round(this.scroller.clientHeight * 0.5) || 400;
  };

  Rail.prototype.setOff = function (btn, off) {
    btn.classList.toggle('is-off', !!off);
    btn.setAttribute('aria-disabled', off ? 'true' : 'false');
  };

  Rail.prototype.update = function () {
    if (!MQ.matches || !this.built) return;
    var mg = this.scroller;
    var sh = mg.scrollHeight;
    var ch = mg.clientHeight;
    var st = mg.scrollTop;
    var max = Math.max(0, sh - ch);
    var trackH = this.track.offsetHeight;

    var ratio = sh > 0 ? Math.min(1, ch / sh) : 1;
    var thumbH = Math.max(MIN_THUMB, Math.round(trackH * ratio));
    if (thumbH > trackH) thumbH = trackH;
    var p = max > 0 ? Math.min(1, Math.max(0, st / max)) : 0;

    this.thumb.style.height = thumbH + 'px';
    this.thumb.style.transform = 'translateY(' + (trackH - thumbH) * p + 'px)';

    /* Ikke display none: layoutet maa ikke hoppe. */
    this.setOff(this.prev, st <= 1);
    this.setOff(this.next, max <= 1 || st >= max - 1);
  };

  /* ---- traek i thumb, klik paa banen ------------------------------------
     Pointer capture: thumb'en faar alle pointermove, ogsaa uden for railen.
     Traek: scrollTop = start + dy * (scroll-afstand / thumb-afstand).
     Klik paa banen: thumb'ens midte lander under markoeren (blid scroll).
     Thumb og bane er ikke fokusbare, og pointerdown kalder preventDefault,
     saa fokus bliver hvor det er, og der markeres ingen tekst. */
  Rail.prototype.geometry = function () {
    var mg = this.scroller;
    var trackH = this.track.clientHeight;
    var thumbH = this.thumb.offsetHeight;
    return {
      max: Math.max(0, mg.scrollHeight - mg.clientHeight),
      travel: Math.max(0, trackH - thumbH),
      thumbH: thumbH
    };
  };

  Rail.prototype.bindDrag = function () {
    var self = this;

    this.onThumbDown = function (e) {
      if (!MQ.matches || (e.pointerType === 'mouse' && e.button !== 0)) return;
      var g = self.geometry();
      if (g.max <= 0 || g.travel <= 0) return;
      e.preventDefault();
      e.stopPropagation();
      self.drag = {
        id: e.pointerId,
        startY: e.clientY,
        startTop: self.scroller.scrollTop,
        ratio: g.max / g.travel
      };
      try {
        self.thumb.setPointerCapture(e.pointerId);
      } catch (err) {
        /* uden capture virker traek stadig, saa laenge markoeren er paa thumb'en */
      }
      self.el.classList.add('is-dragging');
      document.documentElement.classList.add('twrd-rail-dragging');
    };

    this.onThumbMove = function (e) {
      var d = self.drag;
      if (!d || e.pointerId !== d.id) return;
      e.preventDefault();
      self.scroller.scrollTop = d.startTop + (e.clientY - d.startY) * d.ratio;
    };

    this.onThumbUp = function (e) {
      var d = self.drag;
      if (!d || (e && e.pointerId !== d.id)) return;
      self.endDrag();
    };

    this.onTrackDown = function (e) {
      if (e.target === self.thumb) return;
      if (!MQ.matches || (e.pointerType === 'mouse' && e.button !== 0)) return;
      var g = self.geometry();
      if (g.max <= 0 || g.travel <= 0) return;
      e.preventDefault();
      var r = self.track.getBoundingClientRect();
      var top = e.clientY - r.top - self.track.clientTop - g.thumbH / 2;
      var p = Math.min(1, Math.max(0, top / g.travel));
      self.scroller.scrollTo({ top: Math.round(p * g.max), behavior: 'smooth' });
    };

    this.thumb.addEventListener('pointerdown', this.onThumbDown);
    this.thumb.addEventListener('pointermove', this.onThumbMove);
    this.thumb.addEventListener('pointerup', this.onThumbUp);
    this.thumb.addEventListener('pointercancel', this.onThumbUp);
    this.thumb.addEventListener('lostpointercapture', this.onThumbUp);
    this.track.addEventListener('pointerdown', this.onTrackDown);
  };

  Rail.prototype.endDrag = function () {
    if (!this.drag) return;
    var id = this.drag.id;
    this.drag = null;
    try {
      if (this.thumb.hasPointerCapture && this.thumb.hasPointerCapture(id)) {
        this.thumb.releasePointerCapture(id);
      }
    } catch (err) {
      /* capture er allerede sluppet */
    }
    this.el.classList.remove('is-dragging');
    document.documentElement.classList.remove('twrd-rail-dragging');
  };

  Rail.prototype.unbindDrag = function () {
    this.endDrag();
    if (!this.thumb || !this.onThumbDown) return;
    this.thumb.removeEventListener('pointerdown', this.onThumbDown);
    this.thumb.removeEventListener('pointermove', this.onThumbMove);
    this.thumb.removeEventListener('pointerup', this.onThumbUp);
    this.thumb.removeEventListener('pointercancel', this.onThumbUp);
    this.thumb.removeEventListener('lostpointercapture', this.onThumbUp);
    this.track.removeEventListener('pointerdown', this.onTrackDown);
  };

  Rail.prototype.step = function (dir) {
    this.measure();
    this.scroller.scrollBy({ top: dir * this.stepPx, behavior: 'smooth' });
  };

  function init() {
    var medias = document.querySelectorAll('.twrd-gallery-grid');
    for (var i = 0; i < medias.length; i++) {
      if (medias[i].__twrdRail) continue;
      var rail = new Rail(medias[i]);
      /* Behold kun instansen hvis gridet faktisk blev fundet, saa en senere
         init kan naa det naar temaet har renderet galleriet. */
      if (rail.built) medias[i].__twrdRail = rail;
    }
    watch();
  }

  function teardown(scope) {
    var medias = (scope || document).querySelectorAll('.twrd-gallery-grid');
    for (var i = 0; i < medias.length; i++) {
      if (medias[i].__twrdRail) medias[i].__twrdRail.destroy();
    }
  }

  function rebind(media) {
    if (media.__twrdRail) media.__twrdRail.destroy();
    var rail = new Rail(media);
    if (rail.built) media.__twrdRail = rail;
  }

  /* Sikkerhedsnet: twrd-variant-gallery.js udskifter <media-gallery>-noden.
     Hvis eventet nedenfor af en eller anden grund udebliver, opdager denne
     observer at scroll-boksen er en anden node, og binder railen om. */
  function watch() {
    if (!('MutationObserver' in window)) return;
    var medias = document.querySelectorAll('.twrd-gallery-grid');
    for (var i = 0; i < medias.length; i++) {
      (function (media) {
        if (media.__twrdWatch) return;
        var mo = new MutationObserver(function () {
          var current = scrollerOf(media);
          if (!current) return;
          var rail = media.__twrdRail;
          if (!rail || rail.scroller !== current) rebind(media);
        });
        mo.observe(media, { childList: true, subtree: true });
        media.__twrdWatch = mo;
      })(medias[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);

  document.addEventListener('shopify:section:unload', function (e) {
    teardown(e.target);
  });
  document.addEventListener('shopify:section:load', function () {
    init();
  });

  /* Variant-galleriet udskifter <media-gallery>. Railen peger paa den gamle
     node, saa den skal bindes om til den nye. */
  document.addEventListener('twrd:variant-gallery:rendered', function () {
    teardown(document);
    window.requestAnimationFrame(init);
  });
})();
